import React from "react";
import { Box, Container, Typography, Link, Divider, Grid, IconButton } from "@mui/material";
import { Instagram, X, YouTube } from "@mui/icons-material";

function Footer() {
  const snsLinks = [
    { name: "Instagram", icon: <Instagram />, link: "https://www.instagram.com/sekkei_ya/" },
    { name: "X", icon: <X />, link: "https://x.com/_sekkeiya" },
    { name: "YouTube", icon: <YouTube />, link: "https://www.youtube.com/@sekkeiya" }
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "primary.dark",
        color: "white",
        py: 4,
        mt: 5,
      }}
    >
      <Container maxWidth="lg">
        {/* 上部セクション */}
        <Grid container spacing={4} justifyContent="center">
          {/* カラム1：アプリ関連 */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              アプリ情報
            </Typography>
            <Link href="/howto" color="inherit" sx={{ display: "block", mb: 1 }}>
              使い方
            </Link>
            <Link href="/policy" color="inherit" sx={{ display: "block", mb: 1 }}>
              プライバシーポリシー
            </Link>
            <Link href="/terms" color="inherit" sx={{ display: "block", mb: 1 }}>
              利用規約
            </Link>
          </Grid>

          {/* カラム2：外部リンク */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              外部リンク
            </Typography>
            <Link
              href="https://sekkeiyanosagyoubeya.com/"
              color="inherit"
              sx={{ display: "block", mb: 1 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              設計屋の作業部屋
            </Link>
          </Grid>

          {/* カラム3：SNS */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              SNS
            </Typography>
            {snsLinks.map((sns, index) => (
              <IconButton
                key={index}
                href={sns.link}
                color="inherit"
                aria-label={sns.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                {sns.icon}
              </IconButton>
            ))}
          </Grid>
        </Grid>

        {/* 下部のコピーライトとDivider */}
        <Divider sx={{ my: 4, bgcolor: "gray.700" }} />
        <Typography variant="body2" align="center" color="inherit">
          © {new Date().getFullYear()} 設計屋の作業部屋. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
